import type { ComponentPropsWithoutRef } from 'react'

import clsx from 'clsx'
import { $isScheduledShown } from 'features/scheduled-messages/store'
import { StackIcon } from 'shared/ui'

import css from './Header.module.css'

const reset = () => $isScheduledShown.set(false)

export const Header = ({
	className,
	...props
}: ComponentPropsWithoutRef<'header'>) => (
	<header className={clsx(css.header, className)} {...props}>
		<button className={css.back} onClick={reset} type='button'>
			<StackIcon icon='back-arrow' width={16} />
		</button>
		<h1 className={css.title}>Scheduled messages</h1>
	</header>
)
